var _rect, _rect2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNetworkIndicatorNormalMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.65,
    y: 0.65,
    width: 22.7,
    height: 22.7,
    rx: 11.35,
    fill: "#E6F3E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.65,
    y: 0.65,
    width: 22.7,
    height: 22.7,
    rx: 11.35,
    stroke: "#005C00",
    strokeWidth: 1.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12181_46837)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8701 17.3827C12.4445 17.3827 12.9101 16.9171 12.9101 16.3427C12.9101 15.7684 12.4445 15.3027 11.8701 15.3027C11.2957 15.3027 10.8301 15.7684 10.8301 16.3427C10.8301 16.9171 11.2957 17.3827 11.8701 17.3827Z",
    fill: "#005C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5246 9.25185C16.6483 7.71305 14.2968 6.87207 11.8702 6.87207C9.44364 6.87207 7.09207 7.71305 5.21582 9.25185",
    stroke: "#005C00",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4765 11.5442C15.1653 10.5062 13.5419 9.94141 11.8696 9.94141C10.1972 9.94141 8.57391 10.5062 7.2627 11.5442",
    stroke: "#005C00",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4293 13.847C13.6856 13.3061 12.7896 13.0146 11.8699 13.0146C10.9503 13.0146 10.0543 13.3061 9.31055 13.847",
    stroke: "#005C00",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12181_46837"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.38,
    height: 16.38,
    fill: "white",
    transform: "translate(4.45996 3.80957)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkIndicatorNormalMobile);
export default __webpack_public_path__ + "static/media/network_indicator_normal_mobile.05fdf379e797b2518380aa1f6e3cf288.svg";
export { ForwardRef as ReactComponent };